import { GatewayForm, GatewayInfo } from 'models/gateway';
import { ListParams, ListResponse } from './../models/common';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/gateway';
export const gatewayApi = {
  fetchGateways(param: ListParams): Promise<ListResponse<GatewayInfo>> {
    let url;
    if (param.search_label) {
      url = `${urlApi}-list?page_size=${param._limit}&page=${param._page}${param.search_label}`;
    } else {
      url = `${urlApi}-list?page_size=${param._limit}&page=${param._page}`;
    }
    return axiosClient.get(url);
  },
  add(data: GatewayForm): Promise<GatewayInfo> {
    const url = `${urlApi}`;
    return axiosClient.post(url, data);
  },
  update(data: Partial<GatewayInfo>): Promise<GatewayInfo> {
    const url = `${urlApi}/info/${data.id}`;
    return axiosClient.put(url, data);
  },
  remove(id: string): Promise<any> {
    const url = `${urlApi}/${id}`;
    return axiosClient.delete(url);
  },
  fetchGatewayInfo(param: ListParams): Promise<GatewayInfo> {
    const url = `${urlApi}?${param.type}=${param.id}`;
    return axiosClient.get(url);
  },
};
